import React, {useEffect, useState} from 'react'
import {notification} from 'antd'
import {DownloadOutlined} from '@ant-design/icons'
import gql from 'graphql-tag'
import {useLazyQuery} from '@apollo/react-hooks'
import Button from 'components/shared/Button'

const getDownloadUrlQuery = gql`
  query ZipDownloadQuery($id: ID!, $scope: AssetScopes, $size: AssetSizes) {
    product(id: $id) {
      id
      ... on AssetsBasedProduct {
        downloadUrl(scope: $scope, size: $size)
      }
    }
  }
`

const ZipDownloaderButton = ({productId, size = 'original', scope = 'purchased'}) => {
  // Multiple renders can happen when there is an error, but should show the notification only once
  const [showingError, setShowingError] = useState(false)
  const [getDownloadUrl, {loading, data, error}] = useLazyQuery(getDownloadUrlQuery, {fetchPolicy: 'no-cache'})

  const sizeMap = {
    "original": "Trykk",
    "monitor": "Web",
  }

  useEffect(() => {
    const url = (data && data.product) ? data.product.downloadUrl : null
    function isError() {
      if (error) {
        return true
      }
      if (data && !url && !loading) {
        return true
      }
      return false
    }
    if (isError() && !showingError) {
      setShowingError(true)
      notification['error']({
        message: 'Nedlastning feilet',
        description: 'Kunne ikke laste ned ZIP-fil grunnet en feil. Forsøk på nytt senere.',
      })
    } else if (url) {
      window.location = url
    }
  }, [loading, data, error, showingError])

  return (
    <Button
      block
      secondary
      type="action"
      icon={<DownloadOutlined />}
      loading={loading}
      disabled={loading}
      onClick={() => {
        setShowingError(false)
        getDownloadUrl({
          variables: {
            id: productId,
            size,
            scope,
          }
        })
      }}
    >
      {sizeMap[size]}
    </Button>
  )
}

export default ZipDownloaderButton
